module.exports = __webpack_public_path__ + "img/usability-testing-animate.3856c3fb.svg";